<template>
    <div class="payment-feature-warpper position-relative section-space--pt_120" id="contactus">
        <div class="payment-feature">
            <div class="container">
                <!-- <div class="row">
                    <div class="col-lg-12">
                        <div class="section-title text-center section-space--mb_60">
                            <h2 class="font-weight--bold mb-15 wow move-up">Contact Us</h2>
                            <span class="section-text wow move-up">Have some questions? We're here to help.</span>
                        </div>
                    </div>
                </div> -->
                <!-- Payment Feature component -->
                
                <div class="row">
                    <div class="col-lg-4">
                        <div class="section-title section-space--mb_60 text-center text-lg-left">
                            <h2 class="font-weight--bold mb-15 wow move-up">Contact Us</h2>
                            <span class="section-text wow move-up">Have some questions? We're here to help.</span>
                            <hr />
                            <span class="section-text wow move-up"><i class="fa fa-clock"></i> Monday to Friday, 10am to 6pm (GMT +8)</span>
                            <span class="section-text wow move-up"><a href="mailto:support@quicksend.asia"><i class="fa fa-envelope"></i> support@quicksend.asia</a></span>
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <div class="newsletter-form--two section-space--mb_40 text-center wow move-up">
                            <form action="#">
                                <div class="contact-input-one">
                                    <input type="text" placeholder="Your name">
                                    <input type="email" placeholder="Email" class="mr-0">
                                </div>
                                <div class="contact-input-two">
                                    <textarea placeholer="Your message" class="textarea" />
                                </div>
                                <div class="text-right">
                                    <button class="ht-btn ht-btn-md">Subscribe</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="payment_feature_svg vc_row-separator tilt_left bottom"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="none" viewBox="0 0 4 0.266661">
                <linearGradient id="svg-fill-5d3a79b9bb254">
                    <stop offset="0%" stop-color="#F9278E"></stop>
                    <stop offset="100%" stop-color="#f96ab0"></stop>
                </linearGradient>
                <polygon points="4,0 4,0.266661 -0,0.266661" fill="url( #svg-fill-5d3a79b9bb254 )"></polygon>
            </svg>
        </div> -->
    </div>
</template>

<script>
    import PaymentFeature from '../PaymentFeature'

    export default {
        name: 'PaymentFeatureSection',
        components: {
            PaymentFeature
        }
    };
</script>

<style>
    .textarea {
        border-color: transparent;
        background: rgba(0, 0, 0, 0.07);
        border-radius: 5px;
        padding: 3px 20px;
        border: 1px solid transparent;
        margin-bottom: 20px;
        width: 100%;
        height: 168px;
    }
    .contact-input-one input {
        min-width: calc(50% - 8px);
    }
    @media only screen and (max-width: 575px) {
        .contact-input-one input {
            min-width: 100%;
        }
    }
</style>
